import { Outlet, useSearchParams, useSnapshot } from 'umi'
import styles from './index.less'
import Header from './components/Header'
import { useEffect, useRef, useState } from 'react'
import { getToken, setHeaders } from '@/utils/request'
import { wsStore } from '@/states/ws'
import { addCookie, getCookie } from '@/utils/cookie'
import { ConfigProvider, Spin } from 'antd'
import RprmUtils from '@/utils/dot'
import { useStore, setIsLogin, setIsRecord } from '@/states/store'
import { theme } from './config'
import * as Sentry from '@sentry/react'
import { startRecording, stopRecording } from '@/utils/recorder'
import { usePlatform } from '@/pages/create/store'
import Banner from './components/Banner'
import { getQuery } from '@/utils'
export default () => {
  const state = useSnapshot(wsStore)
  // console.log('🚀 ~useSnapshot wsStore:', JSON.stringify(state))
  const baseStore = useStore()
  const query = getQuery()

  const [loading, setLoading] = useState(true)

  const [searchParams, setSearchParams] = useSearchParams()

  const { state: createState } = usePlatform()

  const isReconnect = useRef(false)

  useEffect(() => {
    // 临时解决方案，后续可以优化
    const isCreate = window.location.pathname?.indexOf('/create/') === 0
    console.log('layout pathname', window.location.pathname, isCreate)
    if (!isCreate) {
      createState.copyItemId = undefined
    }
  }, [window.location.pathname])

  useEffect(() => {
    try {
      console.log('baseStore.isLogin', state.webSocketState, baseStore.isLogin, WebSocket.CONNECTING)
      if (baseStore.isLogin) {
        if (state.webSocketState === WebSocket.CONNECTING&&!query?.oemCode) {
          // console.log('🚀 ~ layout init')
          state.init(getCookie('token'))
        }
      } else {
        if (state.webSocketState === WebSocket.OPEN) {
          console.log('🚀 ~ layout close')
          state.close()
        }
      }
    } catch (error) {
      console.log('🚀 ~ layout ~ error:', error)
    }

    RprmUtils.initializePublicParams()
    if (baseStore.isLogin) {
      const userId = getCookie('userId')
      Sentry.captureMessage(`userId dot layout: ${userId}`)
    }
  }, [baseStore.isLogin])

  useEffect(() => {
    console.log('state.webSocketState', state.webSocketState)
    const userId = getCookie('userId')
    Sentry.captureMessage(`user websocket type:${state.webSocketState} , userId :${userId}`)
  }, [state.webSocketState])

  useEffect(() => {
    const start = async () => {
      if (baseStore.isRecord) {
        console.log('Recording is already in progress.')
        return
      }

      try {
        setIsRecord(true)
        const sessionId = await startRecording()
        // if (sessionId) {
        //   console.log('Recording started with session ID:', sessionId)
        // } else {
        //   console.error('Failed to start recording')
        // }
      } catch (error) {
        console.error('Error starting:', error)
      }
    }

    const stop = async () => {
      if (!baseStore.isRecord) {
        console.log('No active recording to stop.')
        return
      }

      try {
        await stopRecording()
        setIsRecord(false)
        console.log('Recording stopped')
      } catch (error) {
        console.error('Error stopping recording:', error)
      }
    }
    if (baseStore.isLogin) {
      start()

      const handleBeforeUnload = () => {
        stop()
      }

      window.addEventListener('beforeunload', handleBeforeUnload)

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload)
        stop()
      }
    } else {
      stop()
    }
  }, [baseStore.isLogin])

  useEffect(() => {
    if (searchParams.get('channelSource')) {
      let source = searchParams.get('channelSource') || ''
      source = source.replace('ai1', '')
      addCookie('channel_source', source, 24 * 7)
      RprmUtils.public({ wc_source: source })
    }
    if (searchParams.get('bd_vid')) {
      addCookie('bd_vid', searchParams.get('bd_vid') || '', 24 * 3)
      let source = searchParams.get('channelSource') || ''
      if (source === 'baiduocpc2') {
        RprmUtils.public({ wc_source: 'baiduocpc2' })
      } else {
        RprmUtils.public({ wc_source: 'baidu' })
      }
    }
    if(window.location.pathname?.indexOf('/xhs') === 0){
      addCookie('channel_source', 'xhs', 24 * 7)
      RprmUtils.public({ wc_source: 'xhs' })
    }
    if (searchParams.get('qhclickid')) {
      addCookie('qhclickid', searchParams.get('qhclickid') || '', 24 * 3)
    }

    setTimeout(() => {
      setLoading(false)
    })
    // window.addEventListener('online', reconnect)
    // window.addEventListener('offline', offLine);
    return () => {
      // window.removeEventListener('online', reconnect)
      // window.removeEventListener('offline', offLine);
    }
  }, [0])

  const reconnect = () => {
    try {
      console.log('设备连接到了网络。', state.webSocketState)
      if (isReconnect.current) return
      isReconnect.current = true
      if (getToken() && state.webSocketState !== 1) {
        state.init(getCookie('token'))
      }
      setTimeout(() => {
        isReconnect.current = false
      }, 3000)
    } catch (err) {}
  }

  const initSentry = () => {
    if (process.env.UMI_ENV === 'dev') {
      return
    }
    // let integrations = []
    // const hasReplays = !/MSIE|Trident/.test(window.navigator.userAgent) && Math.random() <= 0.3 //非IE且30%概率采样
    // if (hasReplays) {
    //   console.log('[sentry] Instrumenting session with rrweb')
    //   integrations.push(new SentryRRWeb())
    // }

    Sentry.init({
      dsn: 'https://4f6bd94ca515424c85ea262bac3569b2@api.xiaoke.cn/zq/fe/sentry/29',
      // autoSessionTracking: true,
      release: process.env.WIME_VERSION,
      environment: process.env.UMI_ENV,
      // integrations,
      tracesSampleRate: 0.02,
      ignoreErrors: ['rprm', 'ResizeObserver', 'umi', 'pdf', 'serviceWorker', 'Loading chunk', 'Request aborted', '未登录'],
    })

    // Sentry.setTag('rrweb.active', hasReplays ? 'yes' : 'no')
  }
  useEffect(() => {
    initSentry()
  }, [])

  return (
    <>
      {!loading && <Banner />}
      {!loading && <Header />}
      {loading && <Spin></Spin>}
      {!loading && (
        <div className={styles.layout} id={'layout'}>
          <ConfigProvider theme={theme}>
            <Outlet />
          </ConfigProvider>
        </div>
      )}
    </>
  )
}
